import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Input } from 'reactstrap';
import lodash from 'lodash'; // library added for debounce functionality
class ActivityReportDataTableZFM extends Component {

  constructor(props) {
    super(props);
    this.state = {
      controls: {
        search: {
          value: ''
        }
      }
    }
    this.searchData = lodash.debounce(this.searchData, 500);
  }

  resetData = () => {
    let { controls } = this.state;
    controls.search.value = '';
    this.setState({
      controls
    })
  }
  searchData = e => {
    this.searchFM(false);
  };

  handleSearchChange = e => {
    this.searchData();
  };


  getSpacificFMData = (data) => {
    this.props.getSpacificFMData(data);
  }

  handleInputChange = (e) => {
    let controlName = e.target.name;
    let controlValue = e.target.value;
    let { controls } = this.state;
    controls[controlName].value = controlValue;
    this.setState({
      controls
    })
    if (controlName === 'search') {
      this.handleSearchChange();
    } else {
      this.searchFM(false);
    }
  }


  searchFM = (download_report) => {
    const { controls } = this.state;
    let reqData = {
      q: controls.search.value,
      download_report: download_report
    }
    this.props.searchZFM(reqData);
  }

  render() {
    let { controls } = this.state;
    const rowsList = (this.props.fleetSales || []).map(f =>
      <tr>
        {/* <td onClick={(e) => this.props.goToMemberSalesReport({ uuid: f.user_id, owner_name: f.owner_name, member_id: f.member_id, region_name: f.region_name })} className="capital-case sales-report-td" style={{ color: '#545cd8', cursor: 'pointer' }}>{f.owner_name}</td> */}
        <td className="zfm-table-value text-left cursor-pointer" style={{ color: '#545cd8', cursor: 'pointer' }} onClick={() => this.getSpacificFMData(f)}>{f.business_name}<br /><span className="zfm-table-value" style={{ textTransform: 'capitalize', color: '#545cd8', cursor: 'pointer' }}>{f.region_name} ({f.area_name})</span></td>
        <td className="zfm-table-value text-center">{f.heal_the_wheel}</td>
        <td className="zfm-table-value text-center">{f.heal_the_wheel_achievement}</td>
        <td className="zfm-table-value text-center">{f.heal_the_wheel_percent}</td>
        <td className="zfm-table-value text-center">{f.driver_training}</td>
        <td className="zfm-table-value text-center">{f.driver_training_achievement}</td>
        <td className="zfm-table-value text-center">{f.driver_training_percent}</td>
        <td className="zfm-table-value text-center">{f.scrap_analysis}</td>
        <td className="zfm-table-value text-center">{f.scrap_analysis_achievement}</td>
        <td className="zfm-table-value text-center">{f.scrap_analysis_percent}</td>
        <td className="zfm-table-value text-center">{f.total_goal}</td>
        <td className="zfm-table-value text-center">{f.total_achievement}</td>
        <td className="zfm-table-value text-center">{f.total_percent}</td>
      </tr>);

    return (
      <div>
        <Row>
          <Col sm="4">
            <Input
              type="text"
              name="search"
              id="search"
              placeholder="Search using FM name or Location"
              className="login-input"
              value={controls.search.value}
              onChange={(e) => this.handleInputChange(e)}
            />
            <div>
              <img src="images/search.svg" className="report-search" alt='search'></img>
            </div>
          </Col>
          {/* {this.props.fleetReportFM && this.props.fleetReportFM.elements && this.props.fleetReportFM.elements.length > 0 && <Col xl="3" md="12" xs="12" className="d-flex cursor-pointer" style={{ justifyContent: 'flex-end', margin: 'auto' }}>
            <img src="images/download.svg" alt='download className="download-report-icon margin-left-10" onClick={(e) => this.searchFleetFm(true)} />&nbsp;&nbsp;
            <span className="Download-Full-Report pull-right" onClick={(e) => this.searchFleetFm(true)} style={{ cursor: 'pointer' }}>Download Full Report</span>
          </Col>} */}
          {this.props.fleetSales && this.props.fleetSales.length > 0 &&
            <Col className="d-flex" style={{ justifyContent: 'flex-end', margin: 'auto' }}>
              <img src="images/download.svg" className="download-report-icon margin-left-10" onClick={() => this.searchFM(true)} alt='download' />&nbsp;&nbsp;
              <span className="Download-Full-Report pull-right" onClick={() => this.searchFM(true)} style={{ cursor: 'pointer' }}>Download Full Report</span>
            </Col>
          }
        </Row>
        <Card className="c-top-15">
          <CardBody>
            <table className="table table-bordered table-responsive">
              <thead style={{ background: '#f6f6f6' }}>
                <tr>
                  {/* <th /> */}
                  {/* <th className="sales-report-th">FM Name & Location</th> */}
                  <th rowSpan="2" className="sales-report-th text-align-center">
                    <div>FM Name [Region (Area)]</div> </th>
                  <th colSpan="3" className="sales-report-th text-align-center">Heal The Wheel </th>
                  <th colSpan="3" className="sales-report-th text-align-center">Driver Training / Digital Training</th>
                  <th colSpan="3" className="sales-report-th text-align-center">Scrap Analysis</th>
                  <th colSpan="3" className="sales-report-th text-align-center">Total</th>
                </tr>
                <tr>

                  <td className="sales-report-th">Target</td>
                  <td className="sales-report-th">Achieved</td>
                  <td className="sales-report-th">% Achieved</td>
                  <td className="sales-report-th">Target</td>
                  <td className="sales-report-th">Achieved</td>
                  <td className="sales-report-th">% Achieved</td>
                  <td className="sales-report-th">Target</td>
                  <td className="sales-report-th">Achieved</td>
                  <td className="sales-report-th">% Achieved</td>
                  <td className="sales-report-th">Target</td>
                  <td className="sales-report-th">Achieved</td>
                  <td className="sales-report-th">% Achieved</td>
                </tr>
              </thead>
              <tbody>
                {rowsList}
              </tbody>
            </table>
            {
              this.props.fleetSales.length <= 0 && <div className="no-data tbl-offtake-summary" style={{ maxWidth: '100%', marginTop: '-20px' }}>
                Currently, there is no data to display
                  </div>
            }
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default ActivityReportDataTableZFM;